import StateProvider from './store';
import BannerList from './sections/list';
import BannerDetails from './sections/details';

export default () => (
  <StateProvider>
    <BannerList />
    <BannerDetails />
  </StateProvider>
);
